import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./VisionAndMission.css";

class VisionAndMissionPage extends Component {
  render() {
    return (
      <>
        <div style={{ textAlign: "justify" }}>
          <Container className="global-container text-center" fluid>
            <Row>
              <Col>
                <h3>UNDERGRADUATE PROGRAM</h3>
              </Col>
            </Row>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Vision</h3>
            <p
              style={{
                fontSize: "18px",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <strong>
                “To graduate professionally competent Electronics and
                Telecommunication engineers with research aptitude and social
                sensitivity.”
              </strong>
            </p>
          </Container>
          <Container
            className="container-style"
            style={{ textAlign: "justify" }}
          >
            <h3 className="text-center mb-4">Mission</h3>
            <strong>
              <ul>
                <li>
                  To innovate constantly and adopt teaching, learning,
                  evaluation strategies to suit the learners, and ensure
                  academic and research conducive infrastructure.
                </li>
                <li>
                  To ensure fruitful collaborations with academia and industry
                  for excellence in academic and research.
                </li>
                <li>
                  To undertake the continuous value addition of faculty and
                  staff with suitable empowerment policies.
                </li>
                <li>
                  To inculcate sensitivity to societal issues, communication
                  skills and teamwork, lifelong learning attitude, and relevant
                  skills amongst the learners.
                </li>
                <li>
                  To ensure holistic, flexibility, inclusivity and all rounded
                  development of the learners.
                </li>
              </ul>
            </strong>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Program Education Objectives (PEO)
            </h3>
            <ul>
              <li>
                Establish themselves in their chosen career paths by
                demonstrating technical competence in design, analysis, and
                maintenance of electronics systems, signal processing,
                communication systems, computer network, etc.
              </li>
              <li>
                Demonstrate leadership, communication, and interpersonal skills,
                creativity and innovation, teamwork, and excellent project and
                finance management skills.
              </li>
              <li>
                Contribute towards the next generation of electronics
                technologies with creative and innovative practices.
              </li>
              <li>
                Demonstrate zeal towards lifelong learning, values, ethics,
                sensitivity to global problems, and prove to be dutiful citizens
                for society.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Programme Outcomes (PO)</h3>
            <p>Engineering Graduates will be able to:</p>

            <ul>
              <li>
                <strong>PO1: Engineering Knowledge:</strong> apply knowledge of
                mathematics, science, engineering fundamentals and an
                engineering specialization to the solution of complex
                engineering problems.
              </li>
              <li>
                <strong>PO2: Problem Analysis:</strong> identify, formulate,
                review research literature, and analyse complex engineering
                problems reaching substantiated conclusions using first
                principles of mathematics, natural sciences, and engineering
                sciences.
              </li>
              <li>
                <strong>PO3: Design & Development of Solutions:</strong> design
                solutions for complex engineering problems and design system
                components or processes that meet the specified needs with
                appropriate consideration for the public health and safety, and
                the cultural, societal, and environmental considerations.
              </li>
              <li>
                <strong>PO4: Conduct Investigation of Complex Problems:</strong>
                Use research-based knowledge and research methods including
                design of experiments, analysis and interpretation of data, and
                synthesis of information to provide valid conclusions.
              </li>
              <li>
                <strong>PO5: Modern Tools Usage:</strong> create, select and
                apply appropriate techniques, resources, and modern engineering
                and IT tools including prediction and modeling to complex
                engineering activities with an understanding of the limitations.
              </li>
              <li>
                <strong>PO6: The Engineer and Society:</strong> apply reasoning
                informed by the contextual knowledge to assess societal, health,
                safety, legal and cultural issues and the consequent
                responsibilities relevant to the professional engineering
                practice.
              </li>
              <li>
                <strong>PO7: Environment & Sustainability:</strong> understand
                the impact of the professional engineering solutions in societal
                and environmental contexts, and demonstrate the knowledge of,
                and need for sustainable development.
              </li>
              <li>
                <strong>PO8: Ethics:</strong> apply ethical principles and
                commit to professional ethics and responsibilities and norms of
                engineering practice.
              </li>
              <li>
                <strong>PO9: Individual & Team work:</strong> function
                effectively as an individual and as a member or leader in
                diverse teams, and in multidisciplinary settings.
              </li>
              <li>
                <strong>PO10: Communication:</strong> communicate effectively on
                complex engineering activities with the engineering community
                and with society at large, such as, being able to comprehend and
                write effective reports and design documentation, make effective
                presentations, and give and receive clear instructions.
              </li>
              <li>
                <strong>PO11: Project management & Finance:</strong> demonstrate
                knowledge and understanding of the engineering and management
                principles and apply these to one’s own work, as a member and
                leader in a team, to manage projects and in multidisciplinary
                environments.
              </li>
              <li>
                <strong>PO12: Life-long Learning:</strong> recognize the need
                for, and have the preparation and ability to engage in
                independent and life-long learning in the broadest context of
                technological change.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Programme Specific Outcomes (PSO)
            </h3>
            <ul>
              <li>
                The ability to understand, analyze, design, prototype, maintain
                and troubleshoot circuits and systems in the domain of
                communication, signal processing, embedded and power
                electronics.
              </li>
              <li>
                The ability to demonstrate good communication skills, teamwork,
                project and finance management skills, sensitivity towards
                environment and society, and attitude of lifelong learning.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">Short Term Goals (up to 2027)</h3>
            <ul>
              <li>
                Higher studies enrollment should be at least 15% of the
                graduating batch.
              </li>
              <li>
                Five reputable journal publications per year in the department.
              </li>
              <li>
                Each faculty should be involved in sponsored research and
                consultancy.
              </li>
              <li>100% faculty with Ph.D. qualification.</li>
              <li>One center of excellence in the department.</li>
              <li>State-of-the-art laboratory in the department.</li>
              <li>
                Co-teaching from the industry experts for 5% of program courses.
              </li>
              <li>Each faculty should be involved in outreach activities.</li>
              <li>
                One active collaboration with top layer institutions of the
                country.
              </li>
              <li>One active collaboration with foreign institutions.</li>
              <li>1% visiting professors from industry/foreign university.</li>
              <li>
                Reaching 80% of our alumni and ensuring their participation in
                mentoring our students.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">
              Establish consistency of PEOs with Mission of the Department
            </h3>
            <p>
              (Generate a “Mission of the Department – PEOs matrix “with
              justification and Rationale of the mapping)
            </p>
            <table>
              <tr>
                <th>PEO/M</th>
                <th>M1</th>
                <th>M2</th>
                <th>M3</th>
                <th>M4</th>
                <th>M5</th>
              </tr>
              <tr>
                <td>
                  <b>PEO1</b>
                </td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO2</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
              <tr>
                <td>
                  <b>PEO3</b>
                </td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO4</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
            </table>
            <br />
            <p>
              Where: M1, M2, M3, M4 and M5 are five elements of Mission
              Statement and PEO1, PEO2, PEO3, PEO4 are Program Education
              Objectives statement.
              <br />
              Enter correlation levels 1, 2 or 3, where the correlation levels
              1, 2 or 3 as defined below:
              <br />
              <ol type="1" style={{ marginLeft: "50px" }}>
                <li>Slightly (Low)</li>
                <li>Moderately (Medium)</li>
                <li>Substantial (High)</li>
                <li>If there is no correlation, put “-“</li>
              </ol>
            </p>
          </Container>
        </div>
        <br />
        <div style={{ textAlign: "justify" }}>
          <Container className="global-container text-center" fluid>
            <Row>
              <Col>
                <h3>POSTGRADUATE PROGRAM</h3>
              </Col>
            </Row>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Vision</h3>
            <p
              style={{
                fontSize: "18px",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <strong>
                “To graduate professionally competent Electronics and Telecommunication engineers with research aptitude and social sensitivity.”
              </strong>
            </p>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Mission</h3>
            <strong>
              <ul>
                <li>
                  To innovate constantly and adopt teaching, learning, evaluation strategies to suit the learners, and ensure academic and research conducive infrastructure.
                </li>
                <li>
                  To ensure fruitful collaborations with academia and industry for excellence in academic and research.
                </li>
                <li>
                  To undertake the continuous value addition of faculty and staff with suitable empowerment policies.
                </li>
                <li>
                  To inculcate sensitivity to societal issues, communication skills and teamwork, lifelong learning attitude, and relevant skills amongst the learners.
                </li>
                <li>
                  To ensure holistic, flexibility, inclusivity and all rounded development of the learners.
                </li>
              </ul>
            </strong>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">
              Program Education Objectives (PEO)
            </h3>
            <p>Within two years of post graduation:</p>
            <ul>
              <li>
                Employable in the diversified sectors of the core industry,
                public sector or Multinational Corporation in the domain of
                design, analysis and maintenance of electronics systems, signal
                processing, communication systems, computer network etc.
              </li>
              <li>
                Contribute towards the next generation of electronics
                technologies with creative and innovative practices.
              </li>
              <li>
                Competent with attitude towards lifelong learning, values,
                ethics, sensitivity to global problems and prove to be dutiful
                citizens for society.
              </li>
            </ul>
          </Container>
          <Container className="container-style">
            <h3 className="text-center mb-4">Programme Outcomes (PO)</h3>
            <p>Engineering Postgraduates will be able to:</p>

            <ul>
              <li>
                <strong>PO1:</strong> Independently carry out research
                /investigation and development work to solve practical problems.
              </li>
              <li>
                <strong>PO2:</strong> Write and present a substantial technical
                report/document.
              </li>
              <li>
                <strong>PO3:</strong> Demonstrate a degree of mastery over the
                area as per the specialization of the program. The mastery
                should be at a level higher than the requirements in the
                appropriate bachelor program.
              </li>
            </ul>
          </Container>

          <Container className="container-style">
            <h3 className="text-center mb-4">
              Establish consistency of PEOs with Mission of the Department
            </h3>
            <p>
              Generate a “Mission of the Department – PEOs matrix “with
              justification and Rationale of the mapping
            </p>
            <table>
              <tr>
                <th>PEO/M</th>
                <th>M1</th>
                <th>M2</th>
                <th>M3</th>
                <th>M4</th>
                <th>M5</th>
              </tr>
              <tr>
                <td>
                  <b>PEO1</b>
                </td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO2</b>
                </td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
                <td>Medium</td>
                <td>Medium</td>
              </tr>
              <tr>
                <td>
                  <b>PEO3</b>
                </td>
                <td>Medium</td>
                <td>Medium</td>
                <td>Medium</td>
                <td>High</td>
                <td>High</td>
              </tr>
            </table>
            <br />
            <p>
              Where: M1, M2, M3, M4 and M5 are five elements of Mission
              Statement and PEO1, PEO2, PEO3 are Program Education Objectives
              statement.
              <br />
              Enter correlation levels 1, 2 or 3, where the correlation levels
              1, 2 or 3 as defined below:
              <br />
              <ol type="1" style={{ marginLeft: "50px" }}>
                <li>Slightly (Low)</li>
                <li>Moderately (Medium)</li>
                <li>Substantial (High)</li>
                <li>If there is no correlation, put “-“</li>
              </ol>
            </p>
          </Container>
        </div>
      </>
    );
  }
}

export default VisionAndMissionPage;
